import integrations from './integrations';
import globalIntegrations from './globalIntegrations';

export const reducerMap = { integrations: globalIntegrations };
const makeReducerMap = (integration) => ({
  [`integrations/${integration}`]: integrations(integration)
});
export default makeReducerMap;
